import { mapGetters, mapMutations } from 'vuex'
import { getProducts } from '@/common/services'

export default {
  computed: {
    ...mapGetters({ oidc: 'oidcUser' })
  },
  methods: {
    ...mapMutations({
      setUserItems: 'SET_USER_ITEMS'
    }),
    async getProducts(entityId) {
      const response = await getProducts({
        userId: this.oidc.sub,
        entityId
      })
      const responseData = response.data
      const APPLICATION = 2
      const PRODUCT = 1
      const applicationsList = responseData.filter(
        item => item.type === APPLICATION
      )
      const productsList = responseData.filter(item => item.type === PRODUCT)
      this.setUserItems({
        applicationsData: applicationsList,
        productsData: productsList
      })
    }
  }
}
